<template>
    <div>
        <div class="form-info">
            <el-form :model="voucher" ref="voucherInfo">
                <div class="form-row">
                    <div class="form-label">
                        <label>预约上门时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{voucher.planTime || ''}}</span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label>计划出发时间</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="planStartOffTime" :rules="{validator: checkStartTime, trigger: 'blur'}">
                            <el-date-picker :disabled="voucher.state > 3 && voucher.state != 7" :clearable="false" type="datetime" placeholder="选择计划出发时间" v-model="voucher.planStartOffTime" :picker-options="pickerOptions0" format="yyyy-MM-dd HH:mm" @change="startTimeChange"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label>预计完成时间</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="estiFinishTime" :rules="{validator: checkEndTime, trigger: 'blur'}">
                            <el-date-picker :clearable="false" type="datetime" placeholder="选择预计完成时间" v-model="voucher.estiFinishTime" :picker-options="pickerOptions1" format="yyyy-MM-dd HH:mm"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-servc-work-voucher-arrange-plan',
        desc: '工单安排计划',
        props: ['voucherId'],
        data: function () {
            return {
                voucher: {},
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        created: function () {
            this.getServcWorkVoucher();
        },
        methods: {
            startTimeChange(){
                let planStartOffTime = this.voucher.planStartOffTime;
                if(Utils.isNoB(planStartOffTime)) {
                    planStartOffTime = Date.now();
                } else {
                    planStartOffTime = Date.parse(planStartOffTime);
                }
                this.pickerOptions1 = {
                    disabledDate(time) {
                        return time.getTime() < planStartOffTime - 8.64e7;
                    }
                }
            },
            checkStartTime: function (rule, value, callback) {
                let voucher = this.voucher;
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    // 计划出发时间不能小于当前时间
                    let planStartOffTime = value.format("yyyy-MM-dd HH:mm");
                    let nowTime = new Date().format("yyyy-MM-dd HH:mm");
                    if(planStartOffTime < nowTime) {
                        callback(new Error('计划出发时间不能小于当前时间!'));
                    } else {
                        callback();
                    }
                }
            },
            checkEndTime(rule, value, callback){
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    // 预计完成时间不能小于当前时间 && 预计完成时间不能小于计划出发时间
                    let estiFinishTime = value.format("yyyy-MM-dd HH:mm");
                    let planStartOffTime = (this.voucher.planStartOffTime || new Date()).format("yyyy-MM-dd HH:mm");
                    if(estiFinishTime <= planStartOffTime) {
                        callback(new Error('预计完成时间必须在计划出发时间（或当前时间）之后!'));
                    } else {
                        callback();
                    }
                }
            },
            getServcWorkVoucher: function () {
                let self = this;
                let params = {};
                params.id = self.voucherId;
                let msgBox = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    msgBox.hide();
                    if(result.type === "info") {
                        self.voucher = result.data;
                        self.startTimeChange();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult(){
                let self = this;
                let voucher = this.voucher;
                let result = {};
                self.$refs['voucherInfo'].validate(function (valid) {
                    if(valid) {
                        let planStartOffTime = voucher.planStartOffTime;
                        let estiFinishTime = voucher.estiFinishTime;
                        let planTime = null;
                        if(voucher.planTime != null) {
                            planTime = voucher.planTime.format('yyyy-MM-dd HH:mm');
                        }
                        let workVoucher = {};
                        workVoucher.id = voucher.id;
                        workVoucher.planStartOffTime = null;
                        workVoucher.estiFinishTime = null;
                        if(!Utils.isNoB(planStartOffTime)) {
                            workVoucher.planStartOffTime = planStartOffTime.format('yyyy-MM-dd HH:mm');
                            if(planTime != null && workVoucher.planStartOffTime > planTime) {
                                result.wran = true;
                            }
                        }
                        if(!Utils.isNoB(estiFinishTime)) {
                            workVoucher.estiFinishTime = estiFinishTime.format('yyyy-MM-dd HH:mm');
                        }
                        //
                        result.type = "info";
                        result.data = workVoucher;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherArrangePlan.vue